import React, { useRef, useState, useEffect } from "react";

// reactstrap components
import {
    Button,
    Card,
    CardBody,
    InputGroup,
    //Row,
    Col
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import * as Helper from "../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../redux/screens/account/RegisterPartnerRedux";
import BaseScreen from "../../components/base/BaseScreen";
import UIDs from "../../UIDs";
import { Link } from "react-router-dom";
import _ from "lodash";
import AppConfig from "../../config/AppConfig";
import { NavigationService } from "../../navigation";

const phoneRegex = /^[0-9-]+$/i;
const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const uid = UIDs.screens.account.activeteacher;

class ActiveTeacherScreen extends BaseScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.ACTIVE_TEACHER_ASYNC]: { done: this._handleActiveTeacherAsyncActionDone, error: this._handleActiveTeacherAsyncActionError },
        };
    }

    localVars = {
        countries:null,
    };

    constructor(props) {
        super(props);
        this.localVars.countries = Helper.getCountries();

        this._handleSubmit = this._handleSubmit.bind(this);
        this._handleChange = this._handleChange.bind(this);
        this._handleChangePhone = this._handleChangePhone.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();

        this.props.getAllCountryCodeAsync();
    }

    render() {
        return (
            <>
                <Col lg="8" md="9">
                    <Card className="bg-secondary shadow border-0">
                        <CardBody className="px-lg-5 py-lg-5">
                            <div className="text-center text-muted mb-4">
                                <big>{this.props.t("activeTeacherTitle")}</big>
                            </div>
                            <RegisterForm
                                {...this.props}
                                stateValue={this.state}
                                countries = {this.localVars.countries}
                                onSubmit={this._handleSubmit}
                                onChange={this._handleChange}
                                onChangePhone={this._handleChangePhone}
                                onUpdateState={this._changesSetting}
                                isDisabled={this.isActionExecuting(ActionTypes.ACTIVE_TEACHER_ASYNC)}
                            />
                        </CardBody>
                    </Card>
                    <Link
                        className="mt-3 row text-muted"
                        to="/account/teacherlogin"
                        style={{ justifyContent: "flex-end", marginRight: 0 }}
                    >
                        <small>{this.props.t("backLogin")}</small>
                    </Link>
                </Col>
            </>
        );
    }

    _handleChange(e) {
        const { name, value } = e.target;
        if (name === "email") {
            this._changesSetting({ email: value });
            return;
        }
    };

    _handleChangePhone(e) {
        const { name, value } = e.target;
        if (name === "phone") {
            this._changesSetting({ phone: _.replace(value, /-/g, '') });
            this.setState({ inputPhone: _.replace(value, /-/g, '') });
        }
    };

    _handleSubmit(data) {
        var newVO = data;
        //newVO.userName = data.firstName;

        const { phone } = data;
        if (phone || this.state.inputPhone !== "") {//update phone
            if (!newVO.countryCode || newVO.countryCode === "") newVO.countryCode = "86-CHN";
            let codes = [];
            codes = newVO.countryCode.split("-");
            let userPhone = phone;
            if(!userPhone || userPhone === "") userPhone = this.state.inputPhone;

            let newPhone = { phone: _.replace(userPhone, /-/g, ''), isoCode: codes[0], countryCode: codes[1] };
            newVO.phone = newPhone;
        } else { //use localState value
            let newPhone1 = { phone: this.props.localState.user.phone, isoCode: this.props.localState.user.isoCode, countryCode: this.props.localState.user.countryCode };
            newVO.phone = newPhone1;
        }

        this.props.activeTeacherAsync(newVO);
    };

    _handleActiveTeacherAsyncActionDone = (data) => {
        this.displaySuccess({ message: this.props.t("succeed") });
    };

    _handleActiveTeacherAsyncActionError = (action) => {
        this.displayError(action.error);
    };

    _changesSetting = newData => {
        var newVO = {
            ...this.props.localState.user,
            ...newData
        };
        this.props.updateSettings(newVO);
    };
}

function RegisterForm(props) {
    const { user, countryCodeList } = props.localState;
    const { register, handleSubmit, watch, errors, clearError, setValue, getValues } = useForm();
    const { id, organization, password, phone, email, countryCode, nationality } = user;
    const userId = id;
    const submitRef = useRef();

    let navParams = NavigationService.getNavParams(props);
    let {referralcode: getReferralCode} = navParams;

    return (
        <form onSubmit={handleSubmit(props.onSubmit)} autoComplete="off" >
            <input readOnly={true}  autoComplete="new-password" type="password" style={{display:"none"}} />
            {AppConfig.ENABLE_RED_ENVELOPE ?
                <>
                    <InputGroup className="input-group-alternative mb-4">
                        <input
                            className="form-control-alternative form-control"
                            name="referralCode"
                            placeholder={props.t("referralCode")}
                            defaultValue={getReferralCode}
                            hidden={getReferralCode}
                            type="text"
                            ref={register({
                                required: false,
                                validate: {
                                    message: value => {
                                        if (value.length > 7) {
                                            return props.t("invalidLength", { name: props.t("teacherReferralCode"), max: 7 });
                                        }
                                        return clearError();
                                    }
                                }
                            })}
                            maxLength={7}
                        />
                    </InputGroup>
                    {errors.referralCode && <div className="text-muted" style={{ clear: "both", marginTop: -20, marginBottom: 20 }}>
                        <small>
                            <span className="text-danger font-weight-700">{errors.referralCode.message}</span>
                        </small>
                    </div>}    
                </>
                : null}         
            <InputGroup className="input-group-alternative mb-4">
                <select
                    name="nationality"
                    className="form-control-alternative form-control"
                    ref={register({ required: props.t("fieldIsRequired") })}
                    defaultValue={nationality}
                    >
                    <option value="">{props.t("nationality")}</option>
                    {Object.keys(props.countries).map((key, index) =>
                        <option key={index} selected={nationality===key} value={key}>{props.countries[key]}</option>)}
                </select>
            </InputGroup>
            {errors.nationality && <div className="text-muted" style={{ marginTop: -20, marginBottom: 20 }}>
                <small>
                    <span className="text-danger font-weight-700">{errors.nationality.message}</span>
                </small>
            </div>}
            <InputGroup className="input-group-alternative mb-4">
                <input
                    className="form-control-alternative form-control"
                    name="organization"
                    placeholder={props.t("name")}
                    defaultValue={organization || ""}
                    type="text"
                    ref={register({
                        required: props.t("fieldIsRequired"),
                        validate: {
                            message: value => {
                                if (value.replace(/\s/g, "").length === 0) {
                                    return props.t("schoolNameSpace");
                                }
                                if (value.length > 50) {
                                    return props.t("invalidLengthH", { name: props.t("schoolName"), max: 50 });
                                }
                                return clearError();
                            }
                        }
                    })}
                    maxLength={100}
                />
            </InputGroup>
            {errors.organization && <div className="text-muted" style={{ marginTop: -20, marginBottom: 20 }}>
                <small>
                    <span className="text-danger font-weight-700">{errors.organization.message}</span>
                </small>
            </div>}
            <InputGroup className="input-group-alternative mb-4">
                <input
                    className="form-control-alternative form-control"
                    name="email"
                    autoComplete="off"
                    placeholder={props.t("email")}
                    defaultValue={email}
                    type="text"
                    ref={register({
                        required: props.t("fieldIsRequired"),
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                            message: props.t("invalidEmailAddress"),
                        },
                        validate: {
                            message: value => {
                                if (value.length > 50) {
                                    return props.t("invalidLength", { name: props.t("email"), max: 50 });
                                }
                                return clearError();
                            }
                        }
                    })}
                    maxLength={100}
                    onChange={props.onChange}
                />
            </InputGroup>
               
                    <div style={{ float: "left", width: "40%" }}>
                        <InputGroup className="input-group-alternative mb-4">
                            <select
                                name="countryCode"
                                className="form-control-alternative form-control"
                                ref={register({ required: props.t("fieldIsRequired") })}
                                defaultValue={countryCode}
                                onChange={e => props.onUpdateState({ countryCode: e.target.value })}
                                key={countryCode+userId}
                            >
                                {countryCodeList != null && countryCodeList.length > 0 ? countryCodeList.map((item, index) =>
                                    <option key={index} value={item.isoCode + "-" + item.countryCode}>{Helper.getCountryName(item.countryCode)}+({item.isoCode})</option>)
                                    : null}
                            </select>
                        </InputGroup>
                        {errors.countryCode && <div className="text-muted" style={{ marginTop: -20, marginBottom: 20 }}>
                            <small>
                                <span className="text-danger font-weight-700">{errors.countryCode.message}</span>
                            </small>
                        </div>}
                    </div>
                    <div style={{ float: "left", width: "56%", marginLeft: 15 }}>
                        <InputGroup className="input-group-alternative mb-4">
                            <input
                                className="form-control-alternative form-control"
                                name="phone"
                                placeholder={props.t("phone")}
                                defaultValue={phone}
                                //type="number"
                                ref={register({
                                    required: props.t("fieldIsRequired"),
                                    pattern: {
                                        value: /^[0-9-]+$/i,
                                        message: props.t("invalidPhone"),
                                    },
                                    validate: {
                                        message: value => {
                                            if (value.length > 20) {
                                                return props.t("invalidLength", { name: props.t("phone"), max: 20 });
                                            }
                                            return clearError();
                                        }
                                    }
                                })}
                                onChange={e => props.onChangePhone(e)}
                                maxLength={20}
                            />
                        </InputGroup>
                        {errors.phone && <div className="text-muted" style={{ clear: "both", marginTop: -20, marginBottom: 20 }}>
                            <small>
                                <span className="text-danger font-weight-700">{errors.phone.message}</span>
                            </small>
                        </div>}
                    </div>         
            <InputGroup className="input-group-alternative mb-4">
                 <input
                        className="form-control-alternative form-control"
                        name="password"
                        placeholder={props.t("password")}
                        defaultValue={password}
                        autoComplete="off"
                        type="password"
                        ref={register({
                            required: props.t("fieldIsRequired"),
                            pattern: {
                                value: /^(?=.*[A-Za-z])(?=.*\d)[\d\D]{8,14}$/,
                                message: props.t("inputInvalidPassword"),
                            },
                        })}
                        maxLength={15}
                        onChange={props.onChange}
                    />
            </InputGroup>
            {errors.password && <div className="text-muted" style={{ marginTop: -20, marginBottom: 20 }}>
                <small>
                    <span className="text-danger font-weight-700">{errors.password.message}</span>
                </small>
            </div>}            
            <div className="text-center">
                <Button className="mt-4" color="primary" disabled={props.isDisabled} onClick={() => submitRef.current.click()}>
                    {props.t("activeTeacher")}
                </Button>
                <input ref={submitRef} type="submit" hidden />
            </div>
        </form>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        activeTeacherAsync: (vo) => dispatch(Actions.activeTeacherAsync(vo)),
        getAllCountryCodeAsync: () => dispatch(Actions.getAllCountryCodeAsync()),
        updateSettings: val => dispatch(Actions.updateSettings(val)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(ActiveTeacherScreen));
